export { default } from './404';
export * from './404';
